import { SVGProps } from 'react'

export const TextSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M926.25224651 58.91160534H97.74775349c-20.71261275 0-38.83614815 18.12353539-38.83614815 38.83614815v155.34459259c0 20.71261275 18.12353539 38.83614815 38.83614815 38.83614815s38.83614815-18.12353539 38.83614815-38.83614815V136.58390164h336.57995021v750.83219672H356.65540741c-20.71261275 0-38.83614815 18.12353539-38.83614816 38.83614815s18.12353539 38.83614815 38.83614816 38.83614815h310.68918518c20.71261275 0 38.83614815-18.12353539 38.83614816-38.83614815s-18.12353539-38.83614815-38.83614816-38.83614815h-116.50844444v-750.83219672h336.57995021V253.09234608c0 20.71261275 18.12353539 38.83614815 38.83614815 38.83614815s38.83614815-18.12353539 38.83614815-38.83614815V97.74775349c0-20.71261275-18.12353539-38.83614815-38.83614815-38.83614815z'
        fill='#666666'
      />
    </svg>
  )
}
